module.exports = function getResource(label, vars = []) {
    let resources = {
        eyeColor: 'Couleur des yeux',
        selectOne: 'sélectionner une option'
    };

    return resources[label];
};
